import * as types from '../action-types'

export const fetchWorkerShifts = (workerID: number, options: Record<string, any>) => ({
  type: types.WORKER_SHIFTS_FETCH_BEGIN,
  workerID,
  options,
})
